import { render, staticRenderFns } from "./SampleResultVibration.vue?vue&type=template&id=1a976605"
import script from "./SampleResultVibration.vue?vue&type=script&lang=js"
export * from "./SampleResultVibration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports